module.exports = __webpack_public_path__ + "img/0311.d779cc03.png";